import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'projectGuests',
  modelName: 'project_guest_access',
  crud: true,
  endpoint: '/v2/project_guest_access'
});
